import React, { useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import theme from "../../components/LayoutComponents/theme";
import Templates from "./Templates/Templates"
import JobProfiles from "./JobProfiles/JobProfiles";
import SkillProfiles from "./SkillProfiles/SkillProfiles";
import Courses from "./Courses/Courses";
import Programs from "./Programs/Programs";
import PdlIngestion from "./PdlIngestion/PdlIngestion";


function Administration({ session, competencies, proficiencies, jobProfiles, setJobProfiles, companies, skillProfiles, setSkillProfiles, courses, setCourses, setPrograms, programs }) {
  const [selectedComponent, setSelectedComponent] = useState("");

  const renderComponent = () => {
    switch (selectedComponent) {
      case "Templates":
        return <Templates
          session={session}
          competencies={competencies}
          proficiencies={proficiencies} />;
      case "Job Profiles":
        return <JobProfiles
          session={session}
          competencies={competencies}
          proficiencies={proficiencies}
          jobProfiles={jobProfiles}
          setJobProfiles={setJobProfiles}
          skillProfiles={skillProfiles}
          companies={companies.filter(c=>c.entityTypeName === 'Employer')}
        />
      case "Skill Profiles":
        return <SkillProfiles
          session={session}
          competencies={competencies}
          proficiencies={proficiencies}
          skillProfiles={skillProfiles}
          setSkillProfiles={setSkillProfiles}
          companies={companies.filter(c=>c.entityTypeName === 'Employer')}
        />
      case "Courses":
        return <Courses
          session={session}
          competencies={competencies}
          proficiencies={proficiencies}
          courses={courses}
          setCourses={setCourses}
          companies={companies.filter(c=>c.entityTypeName === 'Training Provider')}
        />
         case "Programs":
        return <Programs
          session={session}
          competencies={competencies}
          proficiencies={proficiencies}
          courses={courses}
          companies={companies.filter(c=>c.entityTypeName === 'Training Provider')}
          programs={programs}
          setPrograms={setPrograms}
        />
      case "PDL Ingestion":
        return <PdlIngestion session={session} />
      default:
        return <Typography>Select a section from the dropdown.</Typography>;
    }
  };

  return (
    <Box sx={{ p: 4, width: '100%' }}>
      <Typography
        variant="h4"
        sx={{ mb: 3, color: theme.colors.purple, textAlign: "center" }}
      >
        Administration
      </Typography>

      <FormControl fullWidth sx={{ mb: 4, maxWidth: 400, mx: "auto" }}>
        <InputLabel id="component-select-label">Select Section</InputLabel>
        <Select
          labelId="component-select-label"
          value={selectedComponent}
          label="Select Section"
          onChange={(e) => setSelectedComponent(e.target.value)}
        >
          <MenuItem value="Templates">Templates</MenuItem>
          <MenuItem value="Job Profiles">Job Profiles</MenuItem>
          <MenuItem value="Skill Profiles">Skill Profiles</MenuItem>
          <MenuItem value="Courses">Courses</MenuItem>
          <MenuItem value="Programs">Programs</MenuItem>
          <MenuItem value="PDL Ingestion">PDL Ingestion</MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ mt: 2 }}>
        {renderComponent()}
      </Box>
    </Box>
  );
}

export default Administration;
